module.exports = __webpack_public_path__ + "static/media/SocialMediaFlyer.62da89db.jpg";